
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aIqdH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c09c99e6f93d598c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $c09c99e6f93d598c$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\uBAA8\uB4E0 \uC0AC\uC774\uD2B8",
    'navigation.global-shortcuts.apps.align': "\uC815\uB82C",
    'navigation.global-shortcuts.apps.analytics': "\uBD84\uC11D",
    'navigation.global-shortcuts.apps.assets': "\uC790\uC0B0",
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': "\uD68C\uC0AC \uD5C8\uBE0C",
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': "\uBAA9\uD45C",
    'navigation.global-shortcuts.apps.home': "\uD648",
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': "\uD504\uB85C\uC81D\uD2B8",
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': "\uD300",
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\uB2EB\uAE30",
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': "{name} \uC0AC\uC774\uD2B8",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\uD604\uC7AC \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC74C)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "\uC678\uBD80 \uB9C1\uD06C \uC544\uC774\uCF58 \uC5F4\uAE30",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': "(\uB85C\uB4DC \uC911)",
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': "(\uB85C\uB4DC \uC911)",
    'navigation.global-shortcuts.sites': "{productName} \uC0AC\uC774\uD2B8"
};

});


//# sourceMappingURL=ko.7bc4b497.js.map
